import { render, staticRenderFns } from "./ExclusionEditor.vue?vue&type=template&id=f10993a4&"
import script from "./ExclusionEditor.vue?vue&type=script&lang=ts&"
export * from "./ExclusionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports